import React from "react";

import { ErrorDetail } from "../../../components/ErrorDetail/ErrorDetail";

export const Error500: React.FC = () => {
  return (
    <>
      <ErrorDetail variant="error500" />
    </>
  );
};
